"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.examTypes = exports.operationTypes = void 0;
/**
 * Mapping of operation type names to their IDs.
 */
exports.operationTypes = {
    "CEMEX": 1,
    "TRENES": 2,
};
/**
 * Mapping of exams type forms.
 */
exports.examTypes = {
    EXAMEN_SUSTANCIAS: "examen-sustancias",
    OBSERVACION_GENERAL: "observacion-general",
    EXAMEN_SALUD: "examen-salud",
    RESUMEN: "resumen",
};
